import React from 'react';
import type { IconType, IconBaseProps } from 'react-icons';

export const Icon = ({
  icon: IconComponent,
  ...props
}: { icon: IconType } & IconBaseProps) => {
  return <>{IconComponent(props)}</>;
};
